import { render, staticRenderFns } from "./UserImageUpload.vue?vue&type=template&id=68d43024&scoped=true&"
import script from "./UserImageUpload.vue?vue&type=script&lang=ts&"
export * from "./UserImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./UserImageUpload.vue?vue&type=style&index=0&id=68d43024&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d43024",
  null
  
)

export default component.exports